module.exports = __webpack_public_path__ + "img/presto.1a3fb2fd.svg";